"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var repositoryAdmin;
        (function (repositoryAdmin) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.isShowClientInstall = false;
                        this.repositoryAdminCreate = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                let _filter = appn.emptyString;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    createDataTable();
                }
                index.init = init;
                function addEvents() {
                    $('.folderchange').click(function (e) {
                        e.preventDefault();
                        $('.folder').removeClass('active');
                        $(this).parents('.folder').addClass('active');
                        appn.dataTable.uncheckAllRowsBox();
                        _filter = $(this)[0].id;
                        _dataTable.fnDraw(false);
                    });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        aaSorting: [[1, 'asc']],
                        sAjaxSource: 'RepositoryAdmin/DataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')), appn.dataTable.getStateOrDefault('sCustom_1', _filter));
                        },
                        aoColumns: getDtColConfiguration(),
                        fnInitComplete: function () {
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'installBtn', buttonType: 'ManageInstalls', isDataTableToggleBtn: true }
                            ], _initArgs.isShowClientInstall, true);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'addnew', buttonType: 'AddNew' }
                            ], appn.requestUser.isAdminOrHigher);
                            $('#addnew').click(function (e) {
                                e.preventDefault();
                                appn.location.navTo(_initArgs.repositoryAdminCreate);
                            });
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#installBtn').click(function () {
                                if ($(this).css('opacity') === '1') {
                                    index.selectedItems = $('.selectRow:checked');
                                    appn.iframe.openModal({ url: 'RepositoryAdmin/Install/' })
                                        .then(function ($modal) {
                                        $modal.on('hidden.bs.modal', function () {
                                            appn.notifications.updateNotificationTotal();
                                        });
                                    });
                                }
                            });
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Repository Items <b>Name, Type or Category</b> contains a keyword typed in here.'));
                            appn.saveMeState.init(function () {
                                _dataTable.fnDraw(false);
                            }, function () {
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
                function getDtColConfiguration() {
                    switch (_initArgs.isShowClientInstall) {
                        case true: {
                            return [
                                { bSortable: false, sWidth: '3%' },
                                { bSortable: true, sWidth: '50%' },
                                { bSortable: true, sWidth: '20%' },
                                { bSortable: true, sWidth: '10%' },
                                { bSortable: true, sWidth: '15%' }
                            ];
                        }
                        default: {
                            return [
                                { bSortable: false, sWidth: '0%' },
                                { bSortable: true, sWidth: '55%' },
                                { bSortable: true, sWidth: '20%' },
                                { bSortable: true, sWidth: '10%' },
                                { bSortable: true, sWidth: '15%' }
                            ];
                        }
                    }
                }
            })(index = repositoryAdmin.index || (repositoryAdmin.index = {}));
        })(repositoryAdmin = views.repositoryAdmin || (views.repositoryAdmin = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
